import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import Button from '../../../../common/widgets/Button';
import Dialog from '../../../../common/widgets/Dialog';
import Icons from '../../../../common/widgets/Icons';
import { resources } from '../../resources/resources';

export const AuthenticationExpiringDialog = (props: {
  closeDialog: () => void;
  showExpiredDialog: () => void;
}) => {
  const { closeDialog, showExpiredDialog } = props;
  const auth = useAuth();
  const { t: translate } = useTranslation();

  useEffect(() => {
    const id: any = setTimeout(() => {
      showExpiredDialog();
    }, 60 * 1000);

    return () => {
      clearTimeout(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onContinueClick = () => {
    closeDialog();
  };

  const handleLogout = async () => {
    try {
      await auth.signoutRedirect();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };
  return (
    <Dialog className="dialog-s">
      <div className="dialog-content">
        <div className="dialog-image">
          <Icons.WarningRed />
        </div>
        <div className="dialog-title">
          {translate(resources.authenticationWarningDialogs.expiring.title)}
        </div>
        <div className="dialog-text centered">
          {translate(resources.authenticationWarningDialogs.expiring.body)}
        </div>
      </div>
      <div className="dialog-actions vertical">
        <Button onClick={onContinueClick} className="btn btn-solid">
          <span className="btn-text">
            {translate(
              resources.authenticationWarningDialogs.expiring.continue,
            )}
          </span>
        </Button>
        <Button onClick={handleLogout} className="btn btn-outline">
          <span className="btn-text">{translate(resources.logout)}</span>
        </Button>
      </div>
    </Dialog>
  );
};
